import axios from "../utils/axios";

export default class service {
  static baseURL = "super-admin/constant/all";

  static getConstant(data) {
    return axios.get(this.baseURL);
  }
}